export default "\nuniform float size;\nvarying vec2 vUv;\n\nvoid main() {\n  vec4 mvPosition = modelViewMatrix * vec4(position, 1.0);\n  vUv = uv;\n  gl_PointSize = size;\n  gl_Position = projectionMatrix * mvPosition;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/assets/shaders/screw/screw.vert
// module id = TF6J
// module chunks = 1